<template>
  <div class="form_wrapper_inner">
    <h1>Please provide your complete information below.</h1>
    <div class="basic_info">
      <h4>Basic information</h4>
      <div class="line_f clearfix">
        <div>
          <input
            type="text"
            v-model='basic_info.first_name.val'
            placeholder="First Name *"
          >
          <p
            v-show='!f_state.inp1 && basic_info.first_name.init'
            class="state_notice"
          >This is required.</p>
        </div>
        <div>
          <input
            type="text"
            v-model='basic_info.last_name.val'
            placeholder="Last Name *"
          >
          <p
            v-show='!f_state.inp2 && basic_info.last_name.init'
            class="state_notice"
          >This is required.</p>
        </div>
        <div>
          <input
            type="text"
            v-model.trim='basic_info.zoom_id.val'
            placeholder="Zoom account  (optional)"
          >
        </div>
      </div>
      <p class="words_f">Location you plan to work from and contact details.</p>
      <div class="geo_local clearfix">
        <div class='g_line clearfix'>
          <div class='g_child'>
            <el-select
              v-model="basic_info.country.val"
              filterable
              placeholder="Country *"
            >
              <el-option
                v-for="(key, val) of datas.country"
                :label="key"
                :value="val"
                :key="val"
              >
              </el-option>
            </el-select>
            <p
              v-show='!f_state.inp4 && basic_info.country.init'
              class="state_notice"
            >This is required.</p>
          </div>
          <div>
            <el-select
              v-model="basic_info.state.val"
              filterable
              placeholder="State/Province/Region *"
              :loading="state_loading"
            >
              <el-option
                v-for="(key, val) of datas.state"
                :label="val"
                :value="key"
                :key="val"
              >
              </el-option>
            </el-select>
            <!-- <input v-if='false' v-else type="text" v-model.trim="basic_info.state.val"  placeholder="State/Province/Region *"> -->
            <p
              v-show='!f_state.inp5 && basic_info.state.init'
              class="state_notice"
            >This is required.</p>
          </div>
          <div>
            <input
              v-model.trim='basic_info.city.val'
              type="text"
              placeholder="City *"
            >
            <p
              v-show='!f_state.inp6 && basic_info.city.init'
              class="state_notice"
            >This is required.</p>
          </div>
        </div>
        <div class='g_line clearfix'>
          <div>
            <input
              type="text"
              v-model.trim='basic_info.country_code.val'
              placeholder="Country Code *"
            >
            <p
              v-show='!f_state.inp7 && basic_info.country_code.init'
              class="state_notice"
            >This is required.</p>
          </div>
          <div>
            <input
              type="text"
              v-model='basic_info.phone_number.val'
              placeholder="Mobile number *"
            >
            <p
              v-show='!f_state.inp8 && basic_info.phone_number.init'
              class="state_notice"
            >This is required.</p>
          </div>
          <div>
            <el-select
              v-model="basic_info.time_zone.val"
              filterable
              placeholder="Your current time zone *"
            >
              <el-option
                v-for="(val, key) of datas.time_zone"
                :label="key"
                :value="val"
                :key="val"
              >
              </el-option>
            </el-select>
            <p
              v-show='!f_state.inp9 && basic_info.time_zone.init'
              class="state_notice"
            >This is required.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="qualifications">
      <div class='clearfix'>
        <el-select
          v-model="basic_info.english_proficiency.val"
          filterable
          placeholder="Please select your English proficiency *"
        >
          <el-option
            v-for="(key, val) of datas.english_proficiency"
            :label="key"
            :value="val"
            :key="val"
          >
          </el-option>
        </el-select>
        <p
          v-show='!f_state.inp20 && basic_info.english_proficiency.init'
          class="state_notice"
        >This is required.</p>
      </div>
    </div>
    <div class="qualifications">
      <h4>Educational Attainment</h4>
      <div class="clearfix">
        <div>
          <el-select
            v-model="basic_info.educational_attainment.val"
            filterable
            placeholder="Highest Level of Education *"
          >
            <el-option
              v-for="(key, val) of educational_attainment"
              :label="key"
              :value="val"
              :key="key"
            >
            </el-option>
          </el-select>
          <p
            v-show='!f_state.inp10 && basic_info.educational_attainment.init'
            class="state_notice"
          >This is required.</p>
        </div>
        <!-- <div>
          <input type="text" v-model.trim='basic_info.school_name.val' placeholder="School Name *">
          <p v-show='!f_state.inp11 && basic_info.school_name.init' class="state_notice">This is required.</p>
        </div> -->
        <div>
          <el-select
            v-model="basic_info.school_name.val"
            :remote-method="schoolSearch"
            :loading="schoolNameSearchLanding"
            filterable
            remote
            placeholder="Please Search School Name *"
          >
            <el-option
              v-for="(key,val) of searchSchool"
              :label='key'
              :value="key"
              :key="val"
            >
            </el-option>
          </el-select>
          <p
            v-show='!f_state.inp11 && basic_info.school_name.init'
            class="state_notice"
          >This is required.</p>
        </div>

        <div>
          <el-select
            v-model="basic_info.major.val"
            filterable
            placeholder="Major/Specialization *"
          >
            <el-option
              v-for="(key, val) of datas.majors"
              :label="val"
              :value="key"
              :key="val"
            >
            </el-option>
          </el-select>
          <p
            v-show='inp12_complicated'
            class="state_notice"
          >This is required.</p>
        </div>
        <!-- <div>
					<el-upload
					  class="upload-demo"
					  :action="action"
					  :before-upload="beforeUpload"
					  :on-success='upload_s_fn'
					  :on-change='fileListSize'
					  :multiple='false'
					  :show-file-list='false'
					  :file-list="fileList"
					  v-loading.fullscreen.lock='up_loading'
					  element-loading-text="Uploading..."
					  >
					  <input-upload 
					    :init_width='upload_file_wid' 
					    :words='upload_words'
					  >
            </input-upload>
					</el-upload>
					<p v-show='!f_state.inp13 && basic_info.resume.init' class="state_notice">This is required.</p>
				</div> -->
        <!-- <div>
					<el-select v-model="basic_info.exp_teaching_children.val" filterable placeholder="Experience Teaching Chilrden *">
					    <el-option
					      v-for="(key, val) of datas.teaching_experience"
					      :label="key"
					      :value="val"
                :key="val"
              >
					    </el-option>
					</el-select>
					<p v-show='!f_state.inp14 && basic_info.exp_teaching_children.init' class="state_notice">This is required.</p>
				</div>
				<div class='year' v-show='init_years_show'>
					<input type="text" id='years' v-model.trim='basic_info.years_of_teaching.val' placeholder="Years of Teaching *">
					<label for="years">year(s)</label>
					<p v-show='!f_state.inp15 && basic_info.years_of_teaching.init' class="state_notice">This is required.</p>
				</div> -->
      </div>
    </div>

    <div class="form-part">
      <h4>Teaching Experience</h4>
      <div class="clearfix">
        <div>
          <el-select
            v-model="basic_info.teaching_experience.val"
            placeholder="What kind of experience do you have with K-12 education in the US and/or Canada?"
            multiple
          >
            <el-option
              v-for="(key, val) of datas.teaching_experience"
              :label="key"
              :value="val"
              :key="val"
            >
            </el-option>
          </el-select>
          <p
            class="state_notice"
            v-show="!f_state.inp16 && basic_info.teaching_experience.init"
          >This is required.</p>
        </div>
      </div>
    </div>

    <div
      class="form-part"
      v-if="showFillExperience"
      :teachingExperienceValidate="teachingExperienceValidate"
    >
      <h4>Please fill in your teaching experience</h4>
      <ul class="ch-ul ch-two clearfix">
        <li>
          <el-select
            v-model="teachingExperience.total_teaching_experience.val"
            placeholder="In total how much teaching experience do you have?"
          >
            <el-option
              v-for="(key, val) of total_teaching_experience"
              :label="key.option_value"
              :value="key.option_key"
              :key="val"
            >
            </el-option>
          </el-select>
          <p
            class="state_notice"
            v-if="teachingExperience.total_teaching_experience.showFail"
          >This is required.</p>
        </li>
      </ul>
      <div
        class="experience-fill"
        v-for="(item, index) of teachingExperience.teaching_experience_list"
        :key="index"
      >
        <ul class="ch-ul ch-three clearfix">
          <li>
            <input
              type="text"
              v-model.trim="item.organization_name.val"
              placeholder="Organization Name"
            >
            <p
              class="state_notice"
              v-if="item.organization_name.showFail"
            >This is required.</p>
          </li>
          <li>
            <el-select
              v-model="item.job_title.val"
              placeholder="Job Title"
            >
              <el-option
                v-for="(key, val) of datas.job_title"
                :label="key"
                :value="val"
                :key="val"
              >
              </el-option>
            </el-select>
            <p
              class="state_notice"
              v-if="item.job_title.showFail"
            >This is required.</p>
          </li>
          <li>
            <el-select
              v-model="item.period_teaching_experience.val"
              placeholder="Time period"
            >
              <el-option
                :disabled="val > total_teaching_index"
                v-for="(key, val) of period_teaching_experience"
                :label="key.option_value"
                :value="key.option_key"
                :key="val"
              >
              </el-option>
            </el-select>
            <p
              class="state_notice"
              v-if="item.period_teaching_experience.showFail"
            >This is required.</p>
          </li>
          <li>
            <el-button
              @click="experienceDelete(index)"
              v-if="teachingExperience.teaching_experience_list.length > 1"
            >delete</el-button>
          </li>
        </ul>
      </div>
      <el-button
        @click="experienceAdd"
        v-if="teachingExperience.teaching_experience_list.length < 5"
      >+ click here to add more</el-button>
      <h4 v-if="certification_show">Teaching Certificates</h4>
      <ul
        class="ch-ul ch-three clearfix"
        v-if="certification_show"
      >
        <li v-if="Object.keys(datas.certification_tesol).length">
          <el-select
            multiple
            v-model="teachingExperience.certification_tesol.val"
            placeholder="TESOL Certificate"
          >
            <el-option
              v-for="(key, val) of datas.certification_tesol"
              :label="key"
              :value="val"
              :key="val"
            >
            </el-option>
          </el-select>
          <!-- <p class="state_notice" v-if="teachingExperience.teaching_certificate.showFail">This is required.</p> -->
        </li>
        <li v-if="Object.keys(datas.certification_teyl).length">
          <el-select
            multiple
            v-model="teachingExperience.certification_teyl.val"
            placeholder="TEYL Certificate"
          >
            <el-option
              v-for="(key, val) of datas.certification_teyl"
              :label="key"
              :value="val"
              :key="val"
            >
            </el-option>
          </el-select>
        </li>
        <li v-if="Object.keys(datas.certification_other).length">
          <el-select
            multiple
            v-model="teachingExperience.certification_other.val"
            placeholder="Other Certificate"
          >
            <el-option
              v-for="(key, val) of datas.certification_other"
              :label="key"
              :value="val"
              :key="val"
            >
            </el-option>
          </el-select>
        </li>
      </ul>
    </div>
    <div class="form-part">
      <h4>Technical Requirements</h4>
      <ul class="ch-ul ch-two clearfix">
        <li>
          <el-select
            v-model="basic_info.desktop_or_laptop.val"
            placeholder="Will you teach on either a desktop or laptop?"
          >
            <el-option
              v-for="(key, val) of datas.desktop_or_laptop"
              :label="key"
              :value="val"
              :key="val"
            >
            </el-option>
          </el-select>
          <p
            class="state_notice"
            v-if="!f_state.inp17 && basic_info.desktop_or_laptop.init"
          >This is required.</p>
        </li>
      </ul>

      <ul
        class="ch-ul ch-two clearfix"
        v-if="showTechnicalRequirements"
      >
        <li>
          <el-select
            v-model="basic_info.computer_purchase_year.val"
            placeholder="In what year did you purchase your Laptop/Desktop?"
          >
            <el-option
              v-for="(key, val) of datas.computer_purchase_year"
              :label="key"
              :value="val"
              :key="val"
            >
            </el-option>
          </el-select>
          <p
            class="state_notice"
            v-if="!f_state.inp18 && basic_info.computer_purchase_year.init"
          >This is required.</p>
        </li>

        <li>
          <el-select
            v-model="basic_info.pc_type.val"
            placeholder="What operating system is your Laptop/Desktop running?"
          >
            <el-option
              v-for="(key, val) of datas.operating_system"
              :label="key"
              :value="val"
              :key="val"
            >
            </el-option>
          </el-select>
          <p
            class="state_notice"
            v-if="!f_state.inp19 && basic_info.pc_type.init"
          >This is required.</p>
        </li>
      </ul>
    </div>

    <p v-if="showTip">You will be required to submit screenshots of your Technical Specifications & Internet Speeds to ensure that your work from home setup is sufficient for teaching in HAWO AA. The instructions on how to accomplish the aforementioned will be provided to you by your recruiter.</p>

    <div class="allow_rule clearfix">
      <check-box
        class="inline_b"
        :isCheck='f_state.checkbox'
        @checkFn='reciveMsg'
      ></check-box>
      <p>I do not have any criminal records that would show up in a background check which might disqualify me from working with HAWO. </p>
    </div>
    <p
      class="state_notice"
      v-if="!f_state.checkbox && checkboxInit"
    >This is required.</p>

    <div class="allow_rule clearfix">
      <check-box
        class="inline_b"
        :isCheck='f_state.checkbox2'
        @checkFn='reciveMsg2'
      ></check-box>
      <p>All of the information I provided is factual. Any misinformation could lead to my disqualification.</p>
    </div>
    <p
      class="state_notice"
      v-if="!f_state.checkbox2 && checkboxInit2"
    >This is required.</p>

    <a
      class="submit"
      @click="form_result"
    >Submit</a>
    <!-- jobs2careers pixel -->
    <img
      src="//www.jobs2careers.com/conversion2.php?p=3857"
      width="1"
      height="1"
    />
    <!-- Google pixel -->
    <div style="display:inline;">
      <img
        height="1"
        width="1"
        style="border-style:none;"
        alt=""
        src="//www.googleadservices.com/pagead/conversion/852175291/?label=vQZFCMyAxngQu9OslgM&amp;guid=ON&amp;script=0"
      />
    </div>
    <!-- 渠道统计 -->
    <img
      v-if="channelStatus"
      src="https://click.appcast.io/generic-ue8/a7.png?ent=147&e=5728&t=1523371553225"
      style="display: none;"
      width="1px"
      height="1px"
    />
  </div>
</template>
<script>
import input_upload from "@common/input_file";
import checkBox from "@common/input_check_box";
import { isArray, isFunction, deepCopy } from "@js";

const experienceData = {
  organization_name: {
    val: "",
    init: false
  },
  job_title: {
    val: "",
    init: false
  },
  period_teaching_experience: {
    val: "",
    init: false
  }
};

export default {
  data() {
    return {
      // upload_words: 'Resume *（.doc/.docx/.pdf format within 2MB）', //上传提示文案
      // up_loading: false,
      state_change: false, //州省下拉输入切换
      state_loading: false,
      // fileList: [], //上传文件列表 by element
      // upload_file_wid: '475',
      // init_years_show: false,
      datas: {},
      checkboxInit: false,
      checkboxInit2: false,
      f_state: {
        inp1: false,
        inp2: false,
        inp4: false,
        inp5: false,
        inp6: false,
        inp7: false,
        inp8: false,
        inp9: false,
        inp10: false,
        inp11: false,
        inp12: false,
        // inp13: true,
        // inp14: false,
        // inp15: false,
        inp16: false,
        inp17: false,
        inp18: false,
        inp19: false,
        inp20: false,
        checkbox: false,
        checkbox2: false
      },
      basic_info: {
        first_name: {
          val: "",
          init: false
        },
        last_name: {
          val: "",
          init: false
        },
        zoom_id: {
          val: "",
          init: false
        },
        country: {
          val: "",
          init: false
        },
        english_proficiency: {
          val: "",
          init: false
        },
        state: {
          val: "",
          init: false
        },
        city: {
          val: "",
          init: false
        },
        country_code: {
          val: "",
          init: false
        },
        phone_number: {
          val: "",
          init: false
        },
        time_zone: {
          val: "",
          init: false
        },
        educational_attainment: {
          val: "",
          init: false
        },
        school_name: {
          val: "",
          init: false
        },
        major: {
          val: "",
          init: false
        },
        // resume: {
        //   val: '',
        //   init: false
        // },
        // exp_teaching_children: {
        //   val: '',
        //   init: false
        // },
        // years_of_teaching: {
        //   val: '',
        //   init: false
        // }
        teaching_experience: {
          val: [],
          init: false
        },

        desktop_or_laptop: {
          val: "",
          init: false
        },

        computer_purchase_year: {
          val: "",
          init: false
        },

        pc_type: {
          val: "",
          init: false
        }
      },

      teachingExperienceValMark: [],

      teachingExperience: {
        total_teaching_experience: {
          val: "",
          init: false
        },
        // teaching_certificate: {
        //   val: [],
        //   init: false
        // },
        certification_tesol: {
          val: [],
          init: false,
          skip: true
        },
        certification_teyl: {
          val: [],
          init: false,
          skip: true
        },
        certification_other: {
          val: [],
          init: false,
          skip: true
        },
        teaching_experience_list: [deepCopy(experienceData)]
      },
      channelStatus: false,
      total_teaching_experience: [],
      period_teaching_experience: [],
      educational_attainment: [],
      schoolNameSearchLanding: false, //搜索school name
      searchSchool: {},
      SchollNameVal: ""
    };
  },
  mounted() {
    //渠道统计
    this.axios.get("/Boarding/getTutor").then(d => {
      if (d.data.code == "75000") {
        if (
          d.data.res.info.source == 4 &&
          d.data.res.info.source_details == 403
        ) {
          this.channelStatus = true;
        }
      }
    });

    /*请求基本信息*/
    this.axios.get("/common/getConfig").then(
      response => {
        if (response.data && response.data.code == "75000") {
          this.datas = response.data.res;
          this.total_teaching_experience = response.data.res.total_teaching_experience.filter(
            item => item.is_active == "ON"
          );
          this.period_teaching_experience = response.data.res.period_teaching_experience.filter(
            item => item.is_active == "ON"
          );
          this.educational_attainment =
            response.data.res.educational_attainment;
          //  this.educational_attainment = response.data.res.educational_attainment.filter(item=> item.is_active == 'ON')
        }
      },
      () => {
        console.log("service error");
      }
    );

    /*选择国家时，当没有州省的国家，则变为input-text，有则变为下拉*/
    this.$watch(
      function() {
        return this.basic_info.country.val;
      },
      function(n, o) {
        /*cache方法，属于暂时处理的方法，因为联动出现了问题：选择country,state不更新，第二次改变country才会触发更新；
			但是当改变country时候，state会触发更新,日后有其他解决办法在处理*/
        let cache = this.datas["country"];
        this.basic_info.state.val = ""; //清空state
        this.state_loading = true;

        this.axios
          .get("/common/getStatesByCountryId", {
            params: {
              country_id: this.basic_info.country.val
            }
          })
          .then(
            d => {
              if (d.data.code == 75000) {
                this.datas["country"] = {};
                this.datas["country"] = cache;
                this.datas["state"] = d.data.res;
                this.state_loading = false;
                /*州、省切换，当国家切换至没有州或者省的情况时，state下拉变为输入框；功能已经去掉*/
                //this.state_change= d.data.res.length==0? false : true
              }
            },
            () => {
              console.log("error");
            }
          );

        //国家为美国或者加拿大的时候，自动带入国家号101，其他的为空
        let country = this.basic_info.country.val;

        if (country == 1 || country == 2) {
          this.basic_info.country_code.val = "001";
        } else {
          this.basic_info.country_code.val = "";
        }
      }
    );
    // this.$watch(
    //   function() {
    //     //experience of teaching
    //     return this.basic_info.exp_teaching_children.val
    //   },
    //   function(n, o) {
    //     console.log(this.basic_info.exp_teaching_children.val)
    //     if (this.basic_info.exp_teaching_children.val != 1) {
    //       this.init_years_show = true //显示years
    //     } else {
    //       this.init_years_show = false //隐藏years
    //       this.basic_info.years_of_teaching.val = ''
    //     }
    //     this.f_state.inp14 = !this.basic_info.exp_teaching_children.val ? false : true
    //     this.basic_info.years_of_teaching.val = this.basic_info.years_of_teaching.val.replace(/\D+/g, '') // 数字
    //   }
    // )
  },
  methods: {
    teachingExperienceEdit(data, cb) {
      for (let key in data) {
        let item = data[key];
        if (isArray(item)) {
          item.map(ele => this.teachingExperienceEdit(ele, cb));
        } else {
          if (isFunction(cb)) {
            cb(item);
          }
        }
      }
    },

    experienceDelete(index) {
      this.teachingExperience.teaching_experience_list.splice(index, 1);
    },

    experienceAdd() {
      this.teachingExperience.teaching_experience_list.push(
        deepCopy(experienceData)
      );
    },

    mutexExperience() {
      let teachingExperienceVal = this.basic_info.teaching_experience.val;
      let teachingExperienceConfig = [...this.teachingExperienceConfig];
      if (teachingExperienceConfig.length === 0) return;
      if (
        teachingExperienceVal.length > this.teachingExperienceValMark.length
      ) {
        let increaseVal = teachingExperienceVal.filter(
          item => !this.teachingExperienceValMark.includes(item)
        )[0];

        if (increaseVal) {
          teachingExperienceConfig.map((item, index) => {
            if (item.includes(increaseVal)) {
              teachingExperienceConfig.splice(index, 1);
            }
          });

          teachingExperienceConfig.map(item => {
            item.map(v => {
              let index = teachingExperienceVal.indexOf(v);
              if (index > -1) {
                teachingExperienceVal.splice(index, 1);
              }
            });
          });
        }
      }

      this.teachingExperienceValMark = [...teachingExperienceVal];
    },

    form_result() {
      // 提交
      let pass = true;
      this.isSubmit = true;
      // TechnicalRequirements
      if (!this.showTechnicalRequirements) {
        // Technical requirements为no时候 下面2个选项会隐藏 特殊处理
        this.f_state.inp18 = true;
        this.f_state.inp19 = true;
        this.basic_info.computer_purchase_year.val = "";
        this.basic_info.pc_type.val = "";
      }

      // 显示错误提示设置
      for (let attr in this.basic_info) {
        if (this.basic_info[attr].val == "") {
          // Technical requirements为no时候 下面2个选项会隐藏 特殊处理
          if (
            !this.showTechnicalRequirements &&
            ["computer_purchase_year", "pc_type"].includes(attr)
          ) {
            continue;
          }

          this.basic_info[attr].init = true;
        }
      }

      this.checkboxInit = true;
      this.checkboxInit2 = true;

      pass = !Object.values(this.f_state).includes(false);

      // 处理teachingExperience
      if (this.showFillExperience) {
        // 如果为打开状态 需要获取teachingExperience验证状态并获取数据
        // 设置错误提示状态
        this.teachingExperienceEdit(
          this.teachingExperience,
          item => (item.init = true)
        );
        // 此时pass 跟 teachingExperienceValidate 都为true时 才算通过
        pass = pass && this.teachingExperienceValidate;
      }

      if (!pass) return;

      // 准备发送数据
      let formdata = {};

      for (let attr in this.basic_info) {
        formdata[attr] = this.basic_info[attr].val;
      }

      if (this.showFillExperience) {
        formdata.teaching_experience_list = [];
        for (let key in this.teachingExperience) {
          let item = this.teachingExperience[key];
          if (isArray(item)) {
            item.map(ele => {
              let v = {};
              for (let k in ele) {
                v[k] = ele[k].val;
              }
              formdata.teaching_experience_list.push(v);
            });
          } else {
            formdata[key] = item.val;
          }
        }

        // 把教学证书放入teaching_certification组装起来
        formdata.teaching_certification = {};

        [
          "certification_tesol",
          "certification_teyl",
          "certification_other"
        ].forEach(key => {
          formdata.teaching_certification[key] = formdata[key].map(
            cert_code => ({
              cert_code,
              cert_url: ""
            })
          );

          Reflect.deleteProperty(formdata, key);
        });
      }

      const loading = this.$loading();
      this.axios
        .post("/fillform/update", formdata)
        .then(d => {
          loading.close();
          if (d.data.code == 75000) {
            let status = d.data.res.next;
            let exact_state = d.data.res.exact_state;
            if (status) {
              //加入工作流，以后可能会调整模块
              switch (status) {
                case "fillform": // 填写表单页面
                  // 小状态
                  if (exact_state) {
                    // 预筛失败
                    this.$router.replace(`/fillform?status=${exact_state}`);
                    return;
                  }

                  this.$router.push("/fillform");
                  break;
                case "interview": //interview页面
                  this.$router.replace("/book_interview?status=unassigned");
                  break;
                case "pso": //pso页面
                  this.$router.push("/pso");
                  break;
                case "ntt": //ntt页面
                  this.$router.push("/ntt");
                  break;
                case "onboarding": // 个人信息页面
                  this.$router.push("/personal_profile/personal_qa");
                  break;
                case "updatepwd": //修改密码页面
                  this.$router.push("/resetcode");
                  break;
                default:
                  //均不匹配
                  this.$message.error("servers error.");
              }
            }
          } else {
            this.$message.error(d.data.message);
          }
        })
        .catch(err => loading.close());
      /*this.$http.post('/fillform/update',formdata)
			.then(function(d){
				console.log(d)
				if(d.data.code==75000){
					if(this.quali.educational_attainment=='High School Graduate'||this.quali.educational_attainment=='Vocational Course'){
						this.$router.push('pending')
					}else{
						this.$router.push('book_interview')
					}
				}
			},function(){
				console.log('service error')
			})*/
    },

    reciveMsg(msg) {
      //接收子组件消息
      this.f_state.checkbox = msg;
    },

    reciveMsg2(msg) {
      //接收子组件消息
      this.f_state.checkbox2 = msg;
    },
    schoolSearch(val) {
      if (val !== "") {
        this.schoolNameSearchLanding = true;
        this.axios.get("/common/getUniversityList?name=" + val).then(
          d => {
            if (d.data.code == 75000) {
              this.searchSchool = d.data.res;
              this.schoolNameSearchLanding = false;
            }
          },
          () => {
            console.log("error");
          }
        );
      } else {
        this.searchSchool = {};
      }
    }
    // upload_s_fn(response, file, fileList) {
    //   //上传文件成功
    //   if (response.code == 75000) {
    //     this.$message.success(' Upload successful!')
    //     this.up_loading = false
    //     //this.f_state.inp13=true   //2017-10-9 取消必传
    //     this.basic_info.resume.val = response.res.url
    //     this.upload_words = file.raw.name
    //   } else {
    //     //this.f_state.inp13=false
    //   }
    // },
    // fileListSize(response, file, fileList) {
    //   //上传文件更改
    //   //this.fileList=fileList.slice(-1)
    // },
    // beforeUpload(file) {
    //   //文件上传格式限制 by element
    //   const isDoc =
    //     file.type === 'application/pdf' ||
    //     file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
    //     file.type === 'application/msword'
    //   //以下是文件类型对应的type String
    //   //application/pdf .pdf
    //   //application/vnd.openxmlformats-officedocument.wordprocessingml.document .docx
    //   //application/msword   .doc
    //   const isLt2M = file.size / 1024 / 1024 < 2 && file.size > 0
    //   if (!isDoc) {
    //     this.$message.error('Please upload .doc/.docx/.pdf file within 2MB.')
    //   }
    //   if (!isLt2M) {
    //     this.$message.error('Please upload .doc/.docx/.pdf file within 2MB.')
    //   }
    //   if (isDoc && isLt2M) {
    //     this.up_loading = true
    //   }
    //   //this.f_state.inp13=false
    //   return isDoc && isLt2M
    // }
  },
  computed: {
    //是否展示Teaching certificates
    certification_show() {
      return (
        this.datas.certification_tesol ||
        this.datas.certification_teyl ||
        this.datas.certification_other
      );
    },
    total_teaching_index() {
      let total_teaching_experience = this.teachingExperience
        .total_teaching_experience.val;
      for (let [index, value] of this.total_teaching_experience.entries()) {
        if (value.option_key === total_teaching_experience) {
          return index;
        }
      }
      return -1;
    },
    teaching_certificate: {
      get() {
        return this.teachingExperience.teaching_certificate.val;
      },

      set(val) {
        let lastVal = val.slice(-1)[0];
        let key = "11";
        if (lastVal === key) {
          this.teachingExperience.teaching_certificate.val = [key];
        } else {
          let index = val.indexOf(key);
          if (index > -1) {
            val.splice(index, 1);
          }

          this.teachingExperience.teaching_certificate.val = val;
        }
      }
    },
    showTip() {
      return (
        this.showTechnicalRequirements &&
        this.basic_info.computer_purchase_year.val === "2" &&
        ["1", "2"].includes(this.basic_info.pc_type.val)
      );
    },

    showTechnicalRequirements() {
      return this.basic_info.desktop_or_laptop.val === "1";
    },

    teachingExperienceValidate() {
      let res = true;
      this.teachingExperienceEdit(this.teachingExperience, item => {
        item.success = item.skip
          ? true
          : item.val instanceof Array
          ? item.val.length > 0
          : item.val !== "";
        item.showFail = !item.success && item.init;

        if (!item.success) {
          res = item.success;
        }
      });

      return res;
    },

    teachingExperienceConfig() {
      if (!this.datas.teaching_experience) {
        return [];
      }

      let keys = Object.keys(this.datas.teaching_experience);
      if (keys.length === 0) return [];
      return [keys.slice(0, 2), keys.slice(2)];
    },

    showFillExperience() {
      let teachingExperienceVal = this.basic_info.teaching_experience.val;
      let teachingExperienceConfig = this.teachingExperienceConfig;
      if (
        teachingExperienceVal.length === 0 ||
        teachingExperienceConfig.length === 0
      )
        return false;
      return !teachingExperienceVal.includes(
        teachingExperienceConfig.slice(-1)[0][0]
      );
    },

    emp_obj() {
      for (var i in this.datas.state) {
        return false;
      }
      return true;
    },
    // no_pass() {
    //   //提交按钮的置灰状态判断，同时加入业务逻辑，此处逻辑同form_result的注释.
    //   let pass
    //   // if (this.basic_info.exp_teaching_children == 1) {
    //   //   this.basic_info.years_of_teaching = ''
    //   //   this.f_state.inp15 = true
    //   // }
    //   for (var opt in this.f_state) {
    //     if (this.f_state[opt]) {
    //       pass = true
    //     } else {
    //       pass = false
    //       break
    //     }
    //   }
    //   return pass
    // },
    // action: function() {
    //   return '/fillform/uploadResume'
    // },
    inp12_complicated() {
      return !(this.basic_info.major.val !== "") && this.basic_info.major.init;
    }
  },
  components: {
    "input-upload": input_upload,
    checkBox
  },
  watch: {
    // 表单监测
    basic_info: {
      handler: function(o, n) {
        this.basic_info.first_name.val = this.basic_info.first_name.val
          .replace(/\W+/g, "")
          .replace(/\_/g, ""); // 去除特殊符号
        this.basic_info.last_name.val = this.basic_info.last_name.val
          .replace(/\W+/g, "")
          .replace(/\_/g, ""); // 去除特殊符号

        // this.basic_info.school_name.val = this.basic_info.school_name.val
        //   .replace(/[^a-zA-z0-9\s]+/g, '')
        //   .replace(/\^/g, '')

        this.basic_info.phone_number.val = this.basic_info.phone_number.val.replace(
          /\D+/g,
          ""
        );

        this.f_state.inp1 = !this.basic_info.first_name.val ? false : true;
        this.f_state.inp2 = !this.basic_info.last_name.val ? false : true;
        this.f_state.inp4 = !this.basic_info.country.val ? false : true;
        this.f_state.inp5 = !this.basic_info.state.val ? false : true;
        this.f_state.inp6 = !this.basic_info.city.val ? false : true;
        this.f_state.inp7 = !this.basic_info.country_code.val ? false : true;
        this.f_state.inp8 = !this.basic_info.phone_number.val ? false : true;
        this.f_state.inp9 = !this.basic_info.time_zone.val ? false : true;
        this.f_state.inp10 = !this.basic_info.educational_attainment.val
          ? false
          : true;
        this.f_state.inp11 = !this.basic_info.school_name.val ? false : true;
        this.f_state.inp12 = !(this.basic_info.major.val !== "") ? false : true; //处理专业的key值为0时，inp12为false,出现的BUG
        //this.f_state.inp13 = !this.basic_info.resume.val ? false:true //2017-10-9 取消必出传
        // this.f_state.inp14 = !this.basic_info.exp_teaching_children.val ? false : true
        // this.f_state.inp15 = !this.basic_info.years_of_teaching.val ? false : true

        // experience
        this.f_state.inp16 = this.basic_info.teaching_experience.val.length > 0;
        // 互斥
        this.mutexExperience();

        this.f_state.inp17 = this.basic_info.desktop_or_laptop.val != "";
        this.f_state.inp18 = this.basic_info.computer_purchase_year.val != "";
        this.f_state.inp19 = this.basic_info.pc_type.val != "";
        this.f_state.inp20 = !this.basic_info.english_proficiency.val
          ? false
          : true;
      },
      deep: true
    }
  }
};
</script>
<style lang='less' scoped>
.allow_rule {
  margin-top: 40px;
  & > * {
    float: left;
  }
  p {
    line-height: 18px;
    width: 960px;
    padding-left: 10px;
  }
}
.inline_b {
  display: inline-block;
  vertical-align: middle;
}
.form_wrapper_inner {
  p.state_notice {
    padding: 5px 0 5px 15px;
    color: #fd4c6e;
    font-size: 14px;
  }
  & > h1 {
    padding-top: 55px;
    font-size: 16px;
    color: #1e1e1e;
    font-weight: bold;
  }
  .basic_info {
    & > h4 {
      padding-top: 46px;
      font-size: 24px;
      font-weight: bold;
      color: #febf00;
    }
    .line_f {
      padding-top: 30px;
      & > div {
        float: left;
        margin-right: 20px;
        input {
          width: 215px;
          height: 38px;
          color: #000;
          border: 1px solid #cccccc;
          border-radius: 10px;
          outline: none;
          padding-left: 15px;
          box-shadow: 0 2px 2px 1px #ebebeb inset;
        }
      }
      input:focus {
        border-color: #fcc800;
        box-shadow: 0 2px 2px 1px #fff2cc inset;
      }
      :-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #999999;
        opacity: 1;
        font-size: 15px;
      }
      ::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #999999;
        opacity: 1;
        font-size: 15px;
      }
      input:-ms-input-placeholder {
        color: #999999;
        opacity: 1;
        font-size: 15px;
      }
      input::-webkit-input-placeholder {
        color: #999999;
        opacity: 1;
        font-size: 15px;
      }
    }
    & > p {
      font-size: 14px;
      line-height: 20px;
      color: #525252;
    }
    .words_f {
      padding-top: 25px;
    }
    .geo_local {
      width: 768px;
      padding-top: 20px;
      .g_line {
        & > div {
          float: left;
          margin-right: 20px;
        }
        :-moz-placeholder {
          /* Mozilla Firefox 4 to 18 */
          color: #999999;
          opacity: 1;
          font-size: 15px;
        }
        ::-moz-placeholder {
          /* Mozilla Firefox 19+ */
          color: #999999;
          opacity: 1;
          font-size: 15px;
        }
        input:-ms-input-placeholder {
          color: #999999;
          opacity: 1;
          font-size: 15px;
        }
        input::-webkit-input-placeholder {
          color: #999999;
          opacity: 1;
          font-size: 15px;
        }
      }
      select,
      input {
        box-sizing: border-box;
        width: 232px;
        height: 38px;
        border: 1px solid #cccccc;
        border-radius: 10px;
        outline: none;
        padding-left: 15px;
      }
      input {
        box-shadow: 0 2px 2px 1px #ebebeb inset;
      }
      input:focus {
        border-color: #fcc800;
        box-shadow: 0 2px 2px 1px #fff2cc inset;
      }
      select {
        appearance: none;
        -moz-appearance: none;
        -webkit-appearance: none;
        background: url("~@img/select_r_bg.png") no-repeat 179px -1px;
      }
      option {
        font-size: 14px;
        color: #1e1e1e;
        padding: 13px 0;
      }
      option:hover {
        background: orange;
      }
      option:checked {
        background: #eeeeee;
      }
    }
  }
  .qualifications {
    & > h4 {
      padding: 30px 0;
      font-size: 24px;
      font-weight: bold;
      color: #febf00;
    }
    select,
    input {
      box-sizing: border-box;
      width: 475px;
      height: 38px;
      padding-left: 15px;
      border: 1px solid #cccccc;
      border-radius: 10px;
      outline: none;
    }
    select {
      appearance: none;
      -moz-appearance: none;
      -webkit-appearance: none;
      background: url("~@img/select_r_bg.png") no-repeat 437px -1px;
    }
    input[type="text"] {
      box-shadow: 0 2px 2px 1px #ebebeb inset;
    }
    input:focus {
      border-color: #fcc800;
      box-shadow: 0 2px 2px 1px #fff2cc inset;
    }
  }
  & > p,
  & > input[type="checkbox"] {
    display: inline-block;
    vertical-align: middle;
  }
  & > input[type="checkbox"] {
    background: #fff;
  }
  & > a {
    display: block;
    cursor: pointer;
    width: 337px;
    height: 46px;
    border-radius: 10px;
    line-height: 46px;
    text-align: center;
    color: #1e1e1e;
    font-size: 24px;
    background: #fcc800;
    margin: 0 auto;
    margin-top: 98px;
    &:hover {
      background: #fbd131;
    }
    &.cancel {
      background: #cccccc;
      color: #fff;
      cursor: default;
    }
  }
}
.year {
  position: relative;
  label {
    position: absolute;
    left: 386px;
    top: 10px;
    width: 88px;
    height: 20px;
    line-height: 20px;
    border-left: 1px solid #cccccc;
    font-size: 14px;
    color: #999999;
    text-align: center;
  }
}
</style>
<style lang='less'>
.geo_local {
  & > div {
    margin-bottom: 20px;
  }
  & > * {
    float: left;
  }
  .el-select {
    width: 232px;
    input.el-input__inner {
      height: 38px;
      border-radius: 10px;
      border-color: #cccccc;
    }
    :-moz-placeholder {
      /* Mozilla Firefox 4 to 18 */
      color: #999999;
      opacity: 1;
      font-size: 15px;
    }
    ::-moz-placeholder {
      /* Mozilla Firefox 19+ */
      color: #999999;
      opacity: 1;
      font-size: 15px;
    }
    input:-ms-input-placeholder {
      color: #999999;
      opacity: 1;
      font-size: 15px;
    }
    input::-webkit-input-placeholder {
      color: #999999;
      opacity: 1;
      font-size: 15px;
    }
  }
}
div.el-input {
  overflow: hidden;
}
.el-select .el-input i.el-input__icon {
  background: url("~@img/select_r_bg.png") no-repeat center center;
}
.el-icon-caret-top:before {
  content: "";
}
.qualifications {
  & > div > * {
    float: left;
    width: 490px;
    height: 70px;
    &:nth-child(odd) {
      padding-right: 20px;
    }
  }
  .el-select,
  .file_upload_input {
    margin: 0;
    width: 475px;
    height: 38px;
    input.el-input__inner {
      height: 38px;
      border-radius: 10px;
      border-color: orange;
      color: #1e1e1e;
    }
  }
  :-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #999999;
    opacity: 1;
    font-size: 15px;
  }
  ::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #999999;
    opacity: 1;
    font-size: 15px;
  }
  input:-ms-input-placeholder {
    color: #999999;
    opacity: 1;
    font-size: 15px;
  }
  input::-webkit-input-placeholder {
    color: #999999;
    opacity: 1;
    font-size: 15px;
  }
  .file_upload_input > div p {
  }
}

.form-part {
  & > h4 {
    padding: 30px 0;
    font-size: 24px;
    font-weight: bold;
    color: #febf00;
  }

  .ch-ul {
    min-height: 70px;

    > li {
      float: left;
    }

    &.ch-two {
      margin-left: -35px;

      > li {
        width: 475px;
        margin-left: 35px;
      }
    }

    &.ch-three {
      margin-left: -20px;

      > li {
        width: 232px;
        margin-left: 20px;
      }
    }
  }

  .el-button:focus,
  .el-button:hover {
    border-color: #fcc800;
    color: #fcc800;
  }

  input {
    box-sizing: border-box;
    height: 38px;
    width: 100%;
    padding: 0 15px;
    border: 1px solid #cccccc;
    border-radius: 10px;

    &[type="text"] {
      box-shadow: 0 2px 2px 1px #ebebeb inset;
    }

    &:focus {
      border-color: #fcc800;
      box-shadow: 0 2px 2px 1px #fff2cc inset;
    }
  }

  :-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #999999;
    opacity: 1;
    font-size: 15px;
  }

  ::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #999999;
    opacity: 1;
    font-size: 15px;
  }

  input:-ms-input-placeholder {
    color: #999999;
    opacity: 1;
    font-size: 15px;
  }

  input::-webkit-input-placeholder {
    color: #999999;
    opacity: 1;
    font-size: 15px;
  }
}
</style>


// WEBPACK FOOTER //
// fillform_normal.vue?2daa58e4